/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";

import GlideBase from "./index";

export const GlideCarousel = (props = [1, 2, 3, 4]) => {
  return <GlideBase {...props} />;
};
